/**
 * Phạm vi và quyền ghi của người xem — chép luật của `services/audit-service/.../module/PhamVi.java` (bản Java của
 * native `app/pham_vi.py`, ADR-0095 mục 4) để giao diện ẨN đúng nút mà máy chủ sẽ từ chối (ADR-UI-0005).
 *
 * ── VÌ SAO TÍNH Ở ĐÂY, KHÔNG HỎI MÁY CHỦ NHƯ NATIVE ──────────────────────
 * Luật chỉ dựa trên role lớp 1 `TENANT_ADMIN` và các MÃ QUYỀN `audit:*` đã chốt ở `modules/audit/module.yaml`, đều có
 * trong phiên. Máy chủ vẫn kiểm lại mọi lượt — đây chỉ là hiện hay ẩn.
 */

/** Cờ quyền `audit:*` của người xem — khớp các khoá của `QUYEN_AUDIT` (`../../quyen.ts`). */
export interface CoQuyenAudit {
  tongQuan: boolean;
  suKien: boolean;
  xuat: boolean;
  suDungAi: boolean;
  canhBao: boolean;
  canhBaoSua: boolean;
  cauHinh: boolean;
  cauHinhThem: boolean;
  cauHinhSua: boolean;
  cauHinhXoa: boolean;
  kyThuat: boolean;
  vaiQuanTri: boolean;
  vaiThanhTra: boolean;
  vaiTruongDonVi: boolean;
}

export interface PhamViNguoiXem {
  /** Thấy mọi bản ghi của tenant. Quy tắc cảnh báo của CẢ tenant đòi thêm cờ này. */
  toanTenant: boolean;
  /** Mang vai thanh tra mà không phải quản trị: chỉ xem và xuất, mọi lượt ghi bị từ chối. */
  thanhTra: boolean;
  /** Xuất được nhật ký. */
  duocXuat: boolean;
}

/**
 * `PhamVi.cua` của audit-service, phần không cần danh bạ: quản trị → toàn tenant; vai quản trị hoặc thanh tra → toàn
 * tenant; có BẤT KỲ quyền đọc nào mà không mang vai trưởng đơn vị → toàn tenant.
 */
export function phamViNguoiXem(q: CoQuyenAudit, laQuanTri: boolean): PhamViNguoiXem {
  const truong = q.vaiTruongDonVi && !laQuanTri;
  const vaiToan = q.vaiQuanTri || q.vaiThanhTra;
  const docDuoc = q.tongQuan || q.suKien || q.suDungAi || q.canhBao || q.cauHinh;
  return {
    toanTenant: laQuanTri || vaiToan || (!truong && docDuoc),
    thanhTra: q.vaiThanhTra && !laQuanTri,
    duocXuat: laQuanTri || vaiToan || q.xuat,
  };
}

/**
 * `PhamVi.duocGhi`: quản trị → được; thanh tra → KHÔNG (khai báo "người này không được đổi gì" thắng mọi quyền ghi);
 * vai quản trị → được; còn lại theo ma trận (một trong các quyền `can`).
 */
export function duocGhi(q: CoQuyenAudit, laQuanTri: boolean, can: readonly (keyof CoQuyenAudit)[]): boolean {
  if (laQuanTri) return true;
  if (q.vaiThanhTra) return false;
  if (q.vaiQuanTri) return true;
  return can.some((k) => q[k]);
}

/**
 * Quyền ghi theo đúng động từ mà từng endpoint đòi (`CanhBaoController`), đã ghép `toan_tenant` ở chỗ
 * endpoint đòi. Tên giữ y `useQuyenGhiNhatKy` của native để các màn port sang không phải đổi chỗ dùng.
 */
export interface QuyenGhiNhatKy {
  /** Xử lý một cảnh báo (`PATCH /canh-bao/{id}`) — KHÔNG đòi toàn tenant. */
  xuLyCanhBao: boolean;
  /** Sửa quy tắc, quét ngay (`PUT /canh-bao/quy-tac/{ma}`, `POST /canh-bao/quet`). Cần toàn tenant. */
  suaQuyTac: boolean;
  /** Mở trace trong Langfuse (`audit:ky-thuat:read`). */
  kyThuat: boolean;
}

export function quyenGhiNhatKy(q: CoQuyenAudit, laQuanTri: boolean): QuyenGhiNhatKy {
  const { toanTenant } = phamViNguoiXem(q, laQuanTri);
  const suaCanhBao = duocGhi(q, laQuanTri, ['canhBaoSua']);
  return {
    xuLyCanhBao: suaCanhBao,
    suaQuyTac: toanTenant && suaCanhBao,
    kyThuat: laQuanTri || q.kyThuat,
  };
}
